// Shared with forum-meeting-front. This is a display cache, never authorization.
export const SHARED_PROFILE_MAX_BYTES = 3072

export function getSharedProfileCookieName(tokenCookieName) {
  return (
    {
      forumToken_prod: "forumProfile_prod",
      forumToken_qa: "forumProfile_qa"
    }[tokenCookieName] || ""
  )
}

const isObject = value =>
  value !== null && typeof value === "object" && !Array.isArray(value)

function text(value, limit) {
  return typeof value === "string" &&
    value.length <= limit &&
    !Array.from(value).some(
      char => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127
    )
    ? value
    : ""
}

export function normalizeSharedProfile(loginInfo) {
  if (!isObject(loginInfo)) return null
  const source = loginInfo.uf || loginInfo.userInfo || {}
  if (!isObject(source)) return null
  const meritcoId = loginInfo.meritcoId ?? source.meritcoId
  if (
    !(
      (typeof meritcoId === "number" &&
        Number.isSafeInteger(meritcoId) &&
        meritcoId > 0) ||
      (typeof meritcoId === "string" && /^[1-9]\d{0,19}$/.test(meritcoId))
    )
  )
    return null

  const uf = {}
  const limits = {
    username: 128,
    nickname: 128,
    registerName: 128,
    company: 128,
    companyId: 64,
    email: 254,
    mobile: 32,
    headimgurl: 1024
  }
  for (const [key, limit] of Object.entries(limits)) {
    const value =
      key === "companyId" && Number.isSafeInteger(source[key])
        ? String(source[key])
        : source[key]
    if (text(value, limit)) uf[key] = value
  }
  if (uf.headimgurl) {
    try {
      const url = new URL(uf.headimgurl)
      if (
        !["http:", "https:"].includes(url.protocol) ||
        url.username ||
        url.password
      )
        delete uf.headimgurl
    } catch {
      delete uf.headimgurl
    }
  }
  const nameShow = text(loginInfo.nameShow, 128) || uf.nickname || ""
  return { meritcoId, nameShow, uf }
}

export function encodeSharedProfile(loginInfo, token, now = Date.now()) {
  if (
    typeof token !== "string" ||
    !token ||
    token.length > 2048 ||
    !isObject(loginInfo) ||
    loginInfo.registerToken ||
    (loginInfo.loginResult != null && Number(loginInfo.loginResult) !== 1) ||
    (loginInfo.code != null && Number(loginInfo.code) !== 200) ||
    Number(loginInfo.researchRole?.visit) === 1
  )
    return ""
  const profile = normalizeSharedProfile(loginInfo)
  if (!profile) return ""
  try {
    const encode = () =>
      encodeURIComponent(
        JSON.stringify({ v: 1, token, issuedAt: now, profile })
      )
    let value = encode()
    // Keep the account ID and display name, dropping optional fields as needed.
    for (const field of [
      "headimgurl",
      "company",
      "email",
      "registerName",
      "username",
      "mobile",
      "companyId",
      "nickname"
    ]) {
      if (value.length <= SHARED_PROFILE_MAX_BYTES) return value
      delete profile.uf[field]
      value = encode()
    }
    return value.length <= SHARED_PROFILE_MAX_BYTES ? value : ""
  } catch {
    return ""
  }
}

export function decodeSharedProfile(value, token) {
  if (!value || value.length > SHARED_PROFILE_MAX_BYTES || !token) return null
  try {
    const envelope = JSON.parse(decodeURIComponent(value))
    // issuedAt is informational only. Session expiry belongs to the backend.
    if (envelope?.v !== 1 || envelope.token !== token) return null
    return normalizeSharedProfile(envelope.profile)
  } catch {
    return null
  }
}
